import React from "react"
import { FormattedMessage } from "react-intl"
import {
	FiltersType,
	ModuleState,
} from "components/Shared/GlobalFilter/context/interfaces"
import { NON_OPTION } from "./constants"
import {
	BenchmarkTimelineData,
	LevelName,
} from "components/Transactional/Performance/interfaces"
import {
	DEPARTMENTS,
	CATEGORIES,
	SUBCATEGORIES,
	FINELINE,
} from "components/Shared/GlobalFilter/constants"
import { ALL_CODE } from "helpers/service"
import { PENETRATION } from "../BenchmarkTemplateManager/Templates/constants"
import moment from "moment/moment"
import { PHRONESIS_DEFAULT_DATE_FORMAT } from "helpers/temporal"
import { RangeCalendar } from "components/Shared/MultiRangeCalendar"

interface data {
	interval: number
	primaryTrack: number
	secondaryTrack: number
	detailTrack: number
	primaryDate: string
	secondaryDate: string
}

const arrayMapping = (array?: BenchmarkTimelineData[]) => {
	const arrayMap = new Map<string, BenchmarkTimelineData>()
	if (array && array.length > 0) {
		array.forEach((item) => {
			arrayMap.set(item.currentDate, item)
		})
	}
	return arrayMap
}

export const PRIMARY_TRACK = "primaryTrack"
export const SECONDARY_TRACK = "secondaryTrack"
export const DETAIL_TRACK = "detailTrack"
export const PRIMARY_TRACK_ = "primaryTrack_"
export const SECONDARY_TRACK_ = "secondaryTrack_"
export const DETAIL_TRACK_ = "detailTrack_"

export const mapData = (
	metricData: data[],
	otherData?: BenchmarkTimelineData[]
) => {
	if (!metricData) return []
	const otherDataMap = arrayMapping(otherData)

	return metricData.map((item) => {
		const { interval, primaryDate, secondaryDate, detailTrack } = item

		const otherItem = otherDataMap.get(primaryDate)
		const data = otherItem
			? {
					[PRIMARY_TRACK_]: otherItem.currentAmount,
					[SECONDARY_TRACK_]: otherItem.previousAmount,
					[DETAIL_TRACK_]: otherItem.percentageGrowth,
			  }
			: {}

		return {
			interval,
			primaryDate,
			secondaryDate,
			[PRIMARY_TRACK]: item.primaryTrack,
			[SECONDARY_TRACK]: item.secondaryTrack,
			[DETAIL_TRACK]: detailTrack,
			...data,
		}
	})
}

export const isMetricValid = (metric: string) => metric !== NON_OPTION

const FilterTypeMapper: Record<string, string> = {
	department: DEPARTMENTS,
	category: DEPARTMENTS,
	subcategory: CATEGORIES,
	fineline: SUBCATEGORIES,
	item: FINELINE,
}

export const filtersMapper = (
	filters: FiltersType,
	level: LevelName
): React.ReactElement => {
	const messageId =
		"phronesis.transactional.application.commercial.benchmark.timeline.filters"
	const filtersSelected = filters[FilterTypeMapper[level]] ?? []
	let isAllSelected = filtersSelected.some((item) => item.code === ALL_CODE)
	if (!filtersSelected.length) {
		isAllSelected = true
	}
	return (
		<FormattedMessage
			id={messageId}
			values={{
				all: isAllSelected,
				level: FilterTypeMapper[level],
				filters: filtersSelected.map((item) => item.name).join(", "),
			}}
		/>
	)
}

export const metricMapper = (
	metric: string,
	moduleState: ModuleState
): string => {
	if (metric === PENETRATION) {
		const {
			transactional: {
				penetration: { metric, timeline },
			},
		} = moduleState
		return [metric, timeline].join("_")
	}
	return metric.replace(/-/g, "_")
}

export const getFormattedDates = (
	current: RangeCalendar,
	previous: RangeCalendar
) => {
	return {
		currentFrom: moment(current.startDate).format(
			PHRONESIS_DEFAULT_DATE_FORMAT
		),
		currentTo: moment(current.endDate).format(PHRONESIS_DEFAULT_DATE_FORMAT),
		previousFrom: moment(previous.startDate).format(
			PHRONESIS_DEFAULT_DATE_FORMAT
		),
		previousTo: moment(previous.endDate).format(PHRONESIS_DEFAULT_DATE_FORMAT),
	}
}
